import React from "react";
import {displayCriticality, getImage, sliceText} from "../../utils/utils";
import {LinearProgressBar} from "../progress-bar/LinearProgressBar";
import {calculateDifferenceDeadlineAndNoW, getDateInFrench} from "../../utils/dateUtils";
import styled from "styled-components";
import accountSVG from "../../images/account.svg";


const ActionCardNoInteraction = ({
                                     picture,
                                     firstName,
                                     lastName,
                                     actionName,
                                     criticality,
                                     deadline,
                                     advancement,
                                 }) => {

    return (
        <Card>
            <FlexRow>
                <h3> {sliceText(actionName, 70)} </h3>
                {displayCriticality(criticality)}
            </FlexRow>
            <Pilot>
                <div>
                    <img src={getImage(picture, accountSVG)} alt="pilote"/>
                    <p> {firstName} {lastName}</p>
                </div>
            </Pilot>
            {advancement !== 100 &&
            <Paragraph> {getDateInFrench(deadline)} {calculateDifferenceDeadlineAndNoW(deadline)} </Paragraph>
            }
            {LinearProgressBar(advancement)}
        </Card>
    )
}

const FlexRow = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  width: 100%;
  gap: 0.5em;

  h3 {
    font-size: 14px;
    font-weight: 700;
    text-align: left;
    color: var(--color-white);
    flex-grow: 1;
  }

  div:first-child + p {
    display: none;
  }

`
const Paragraph = styled.p`
  color: var(--color-white) !important;

  span {
    color: var(--color-white) !important;
  }
`
const Card = styled.div`
  background-color: var(--color-blue);
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  height: 10em;
  justify-content: space-evenly;
  align-items: flex-start;
  padding: 1em;
  gap: 0.2em;
  width: 250px;

  p {
    color: var(--color-white) !important;
  }

  .advancement-div {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    align-self: flex-start;

    p {
      padding-right: 0.5em;
    }

    .progress-container {
      height: 0.6rem;
      background: #FAFAFA;
      border-radius: 15px;
      width: 9rem;

    }
  }

  @media (min-width: 700px) {
    margin: 0;
  }
`
const Pilot = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  img {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 0.5em;
  }

  div:first-child {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

`
export default ActionCardNoInteraction